// Script pour ajuster dynamiquement le top du header selon la hauteur de la utility-bar
function setHeaderTopFromUtilityBar() {
  const utilityBar = document.querySelector('.utility-bar');
  const header = document.querySelector('.header');
  const main = document.querySelector('main');
  const headerMenu = document.querySelector('.menu-drawer__inner-container');

  const headerFullHeight = header.offsetHeight + utilityBar.offsetHeight;

  if (header && main) {
    const height = utilityBar?.offsetHeight || 0;
    header.style.top = height + 'px';
    main.style.setProperty('margin', `${headerFullHeight}px 0 0 0`, 'important');
  } else if (header) {
    header.style.top = '';
    main.style.marginTop = '';
  }

  if (headerMenu) {
    headerMenu.style.height = `calc(100vh - ${headerFullHeight}px)`;
  }
}

// Exécute au chargement
window.addEventListener('DOMContentLoaded', setHeaderTopFromUtilityBar);
// Exécute au redimensionnement
window.addEventListener('resize', setHeaderTopFromUtilityBar); 